import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import styles from '../../../css/reports/Reports.module.css'
import { getData } from '../../../actions/servicesHttp'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { Button, ButtonGroup } from 'reactstrap'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function ReportedDevicesReport () {
  const { t, ready } = useTranslation('reportedDevicesReport')
  const { user } = store.getState()
  const role = user.roles
  const navigate = useNavigate()
  const [urlReportedDevicesReport] = useState('reports/reported-devices-report')
  const [reportedDevicesReport, setReportedDevicesReport] = useState(null)
  const [statusFilter, setStatusFilter] = useState('open')

  const columns = [
    { field: 'denunciationStatus', header: t('headers.one') },
    { field: 'id_user', header: t('headers.two') },
    { field: 'serial_number', header: t('headers.three') },
    { field: 'last_date', header: t('headers.four') },
    { field: 'denunciationNumber', header: t('headers.five') },
    { field: 'denunciationDate', header: t('headers.six') },
    { field: 'incidentDate', header: t('headers.seven') },
    { field: 'file', header: t('headers.eight') },
    { field: 'investigator', header: t('headers.nine') },
    { field: 'createdAt', header: t('headers.ten') },
    { field: 'user', header: t('headers.eleven') },
    { field: 'recoveryDate', header: t('headers.twelve') },
    { field: 'closeDate', header: t('headers.thirteen') },
    { field: 'closeUser', header: t('headers.fourteen') }
  ]

  // Filtro de estado
  const status = [
    { name: t('button1'), value: 'open' },
    { name: t('button2'), value: 'monitoring' },
    { name: t('button3'), value: 'close' },
    { name: t('button4'), value: 'all' }
  ]

  const getReportedDevicesReport = async (statusFilter) => {
    const response = await getData(urlReportedDevicesReport, JSON.stringify({ statusFilter }), navigate)

    if (response?.status === 200) {
      const devices = response?.data
      const array = []
      devices.forEach((info) => {
        let element
        const userCreate = info.user
        const userClose = info.closeUser
        const device = info.device

        delete info.user
        delete info.closeUser
        delete info.device

        info.closeUser = userClose === null && info.denunciationStatus === 'close' ? t('label1') : userClose === null ? t('noDisponible') : userClose?.user
        info.user = userCreate === null ? t('label1') : userCreate?.user
        info.closeDate = info.closeDate === null ? t('noDisponible') : formatDate(info.closeDate)
        info.createdAt = info.createdAt === null ? t('noDisponible') : formatDate(info.createdAt)
        info.denunciationDate = formatDate(info.denunciationDate)
        info.incidentDate = formatDate(info.incidentDate)
        info.recoveryDate = info.recoveryDate === null ? t('noDisponible') : formatDate(info.recoveryDate)
        info.denunciationStatus = info.denunciationStatus === 'open' ? t('label2') : info.denunciationStatus === 'monitoring' ? t('label3') : t('label4')

        const soSplit = device?.so?.split('_-_') || []
        const so = soSplit.length > 1 ? `${soSplit[0]} ${soSplit[1]}` : soSplit[0] || ''
        device.so = so

        const modelSplit = device?.model?.split('_-_') || []
        const model = modelSplit.length > 1 ? `${modelSplit[0]} ${modelSplit[1]}` : modelSplit[0] || ''
        device.model = model

        device.last_date = device.last_date === null ? t('noDisponible') : formatDate(device.last_date)

        element = info
        element = {
          ...element,
          ...device
        }

        array.push(element)
      })
      setReportedDevicesReport(array)
    } else {
      setReportedDevicesReport([])
    }
  }
  useEffect(() => {
    if (ready) {
      getReportedDevicesReport(statusFilter)
    }
  }, [statusFilter, ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button5')}
              </Button>
          </NavLink>
        </div>
        <div className={styles.btnsContainer}>
            <ButtonGroup className={styles.dateFilterContainer}>
              {status.map((state, index) => (
                <ToggleButton
                  key={index}
                  id={`state-${index}`}
                  type="radio"
                  variant="secondary"
                  name="state"
                  value={state.value}
                  checked={state.value === statusFilter}
                  className={styles.btnDateReport}
                  onChange={(e) => {
                    setStatusFilter(e.target.value)
                    setReportedDevicesReport(null)
                  }}
                >
                  {state.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div>
        <div>
          {reportedDevicesReport === null && <Loading color="primary" />}
          {reportedDevicesReport !== null && <DataTableDemo
            data={reportedDevicesReport}
            reload={() => getReportedDevicesReport(statusFilter)}
            editUsers={false}
            rowStates={false}
            rowSelecteds={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            actionDelete={false}
            actionDashboard={false}
            table="reportedDevicesReport"
            searchs={['id_user', 'serial_number']}
            columns={columns}
            namePdf={t('namePdf')}
          />}
        </div>
      </div>
    </div>
  )
}
